import { createReducer } from '../../../data/utils/reducers';

import { REQUEST_LIBRARY_FILTERS_LIST, COMPLETE_LIBRARY_FILTERS_LIST, LIBRARY_FILTERS_DELETE_ITEM } from './consts';

const initialState = {
	isFetching: false,
	list: [],
};

const requestData = (state) => {
	return {
		...state,
		isFetching: true,
	};
};

const completeData = (state, action) => {
	const { items } = action.payload;

	return {
		...state,
		isFetching: false,
		list: items,
	};
};

const deleteDataItem = (state, action) => {
	const { filterId } = action.payload;
	const list = state.list.filter((item) => item.id !== filterId);

	return {
		...state,
		isFetching: false,
		list,
	};
};

export const libraryFiltersReducer = createReducer(initialState, {
	[REQUEST_LIBRARY_FILTERS_LIST]: requestData,
	[COMPLETE_LIBRARY_FILTERS_LIST]: completeData,
	[LIBRARY_FILTERS_DELETE_ITEM]: deleteDataItem,
});
